// import Styles from './styles';

import { Superior } from './Superior';

export const Navbar = () => {
  return <Superior />;
};
